import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CustomLookupService {
    title = 'Custom Lookup Service';
    constructor() {}
    retrieveCustomLookup(path, callback) {}
}
